import React from 'react';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';

export default function Structure() {
  const formats = [
    {
      num: "01",
      tag: "Format 1",
      title: "Peer-to-Peer<br/>Board Meeting",
      freq: "1 Tag pro Monat · Wiederkehrend",
      modeText: "Gruppe · branchengemischt",
      modeColor: "text-brand-gold",
      features: [
        "Max. 4 Mitglieder pro Kreis",
        "Gleiche Herausforderungen, nie dieselbe Branche",
        "Strukturiert wie ein echtes Board",
        "Harald moderiert & hält den Rahmen"
      ],
      rule: "<strong>Die Kernregel:</strong> Nie zwei Personen aus derselben Branche — in keinem der drei Kreise."
    },
    {
      num: "02",
      tag: "Format 2",
      title: "Persönliches<br/>Sparring 1:1",
      freq: "1 Stunde pro Woche · Fixer Termin",
      modeText: "Ausschließlich 1:1",
      modeColor: "text-[#5cb88a]",
      features: [
        "Für alles, was nicht in den Kreis gehört",
        "Aktuelle Entscheidungen & was gerade drückt",
        "Führungsthemen & persönliche Entwicklung",
        "Vertraulich — kein Dritter hört zu"
      ],
      rule: "<strong>Der Unterschied:</strong> Das 1:1 gibt den vertraulichen Raum für persönliche Themen."
    }
  ];

  return (
    <section id="struktur" className="py-32 relative z-10 border-t border-brand-border">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="02" 
          eyebrow="Die Sparring Struktur" 
          title="Zwei Formate.<br/><em class='not-italic italic text-brand-gold'>Eine Partnerschaft.</em>" 
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          {formats.map((format, idx) => (
            <Reveal key={idx} delay={idx * 0.1} className="h-full">
              <div className="bg-brand-surface border border-brand-border p-10 lg:p-14 h-full flex flex-col hover:border-brand-gold/30 transition-colors duration-500">
                {/* Topbar */}
                <div className="flex justify-between items-start mb-10">
                  <div className="text-[0.7rem] font-bold tracking-[0.2em] uppercase text-brand-gold border border-brand-gold/30 px-4 py-2">
                    {format.tag}
                  </div>
                  <div className="font-serif text-[3rem] font-light text-brand-border2/30 leading-none">{format.num}</div>
                </div>

                {/* Content */}
                <div className="flex-grow flex flex-col">
                  <h3 className="font-serif text-[2.2rem] font-normal text-brand-white leading-tight mb-4 min-h-[5.5rem]" dangerouslySetInnerHTML={{__html: format.title}} />
                  <div className="text-[0.9rem] font-semibold text-brand-muted mb-8">{format.freq}</div>
                  
                  <ul className="list-none space-y-4 mb-12">
                    {format.features.map((feature, i) => (
                      <li key={i} className="text-[1.05rem] text-brand-text flex items-start gap-4 leading-relaxed italic">
                        <span className="text-brand-gold font-bold shrink-0 mt-[2px]">—</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Footer Rule (Bottom Aligned) */}
                <div className="mt-auto p-6 bg-brand-black border-l-2 border-brand-gold">
                  <p className="text-[0.9rem] text-brand-muted leading-relaxed font-light" dangerouslySetInnerHTML={{__html: format.rule}} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}